



































import Vue from "vue";
import Web3 from "web3";
import { AbiItem } from "web3-utils";
import GenericContractABI from "../../assets/BEP20ContractABI.json";
import AstroshotV2ABI from "../../assets/astronaut/astroshotv2_abi.json";

export default Vue.extend({
  name: "Investing",

  data: () => ({
    web3: undefined as Web3 | undefined,
    connected: false as boolean,
    walletAddress: " " as string,
    balance: " " as string,
    nautTokenBalance: " " as string,
    nautContractAddress: Web3.utils.toChecksumAddress("0x05B339B0A346bF01f851ddE47a5d485c34FE220c"),
    presaleContractAddress: "" as string,
    isWhitelisted: " " as string,
    maxInvestment: 0 as number,
    yourInputTokenBalance: 0 as number,
    outputTokenName: " " as string,
    inputTokenContractAddress: "" as string,
    inputTokenSymbol: "" as string,
    inputTokenDecimals: 0 as number,
    investment: 0 as number,
    isApproved: false as boolean,
    hasAcquired: false as boolean,
    sendBnb: "" as string,
    gasLimit: "1000000" as string,
    gasPrice: "5" as string,
    gas: "0.005" as string,
    transactionResults: [] as Array<string>,
  }),
  methods: {
    async connect(): Promise<void> {
      const { ethereum } = window as any;
      if (!(ethereum /*&& ethereum.isMetaMask*/)) {
        alert("MetaMask がインストールされていません。");
      } else {
        const accounts = await ethereum.request({ method: "eth_requestAccounts" });
        this.web3 = new Web3(ethereum);
        const chainId = await this.web3.eth.getChainId();
        if (chainId != 56) {
          this.web3 = undefined;
          alert("BSC ネットワークで接続してください。");
        } else {
          ethereum.on("accountsChanged", () => {
            window.location.reload();
          });
          ethereum.on("chainChanged", () => {
            window.location.reload();
          });

          this.walletAddress = accounts[0];
          this.balance = Web3.utils.fromWei(await this.web3.eth.getBalance(this.walletAddress), "ether");

          const genericContractAbi = GenericContractABI as any as AbiItem;
          const nautContractAddress = Web3.utils.toChecksumAddress("0x05B339B0A346bF01f851ddE47a5d485c34FE220c");
          const nautContract = new this.web3.eth.Contract(genericContractAbi, nautContractAddress);

          const results = await Promise.all<number, number>([
            nautContract.methods.balanceOf(this.walletAddress).call(),
            nautContract.methods.decimals().call(),
          ]);
          this.nautTokenBalance = (results[0] / Math.pow(10, results[1])).toString();

          this.connected = true;
        }
      }
    },
    async click(): Promise<void> {
      if (this.web3 == null || !this.connected) {
        alert("MetaMask と接続してください。");
        return;
      }

      if (!this.hasAcquired) {
        alert("PresaleAdress を入力してください。");
        return;
      }

      try {
        this.transactionResults.splice(0);

        const presaleContractAbi = AstroshotV2ABI as any as AbiItem;
        const presaleContract = new this.web3.eth.Contract(presaleContractAbi, Web3.utils.toChecksumAddress(this.presaleContractAddress));

        const amount = Web3.utils.toBN(this.investment * Math.pow(10, this.inputTokenDecimals));
        const data = presaleContract.methods.Investing(amount).encodeABI();

        // const nonce = await this.web3.eth.getTransactionCount(this.walletAddress);
        const transaction = {
          from: this.walletAddress,
          to: Web3.utils.toChecksumAddress(this.presaleContractAddress),
          // value: Web3.utils.toWei(this.sendBnb, "ether"),
          data: data,
          gas: this.gasLimit,
          gasPrice: Web3.utils.toWei(this.gasPrice, "gwei"),
          // nonce: nonce,
        };

        this.web3.eth
          .sendTransaction(transaction)
          .on("receipt", (receipt) => {
            const transactionStatus = receipt.status ? "Success" : "Failed";
            this.transactionResults.push(`transactionHash: ${receipt.transactionHash}, result: ${transactionStatus}`);
          })
          .on("error", (error) => {
            this.transactionResults.push(error.message);
          });
      } catch (error: any) {
        this.transactionResults.push(error);
      }
    },
    async approve(): Promise<void> {
      if (this.web3 == null || !this.connected) {
        alert("MetaMask と接続してください。");
        return;
      }

      if (!this.hasAcquired) {
        alert("PresaleAdress を入力してください。");
        return;
      }
      this.transactionResults.splice(0);

      const genericContractAbi = GenericContractABI as any as AbiItem;
      const inputTokenContract = new this.web3.eth.Contract(genericContractAbi, Web3.utils.toChecksumAddress(this.inputTokenContractAddress));

      const data = inputTokenContract.methods
        .approve(Web3.utils.toChecksumAddress(this.presaleContractAddress), Web3.utils.toBN("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"))
        .encodeABI();

      const transaction = {
        from: this.walletAddress,
        to: Web3.utils.toChecksumAddress(this.inputTokenContractAddress),
        data: data,
      };
      try {
        const approveResult = await this.web3.eth.sendTransaction(transaction);
        if (approveResult.status == true) {
          this.isApproved = true;
        }
      } catch (error: any) {
        this.transactionResults.push(error);
      }
    },
  },
  watch: {
    async presaleContractAddress(newValue, oldValue) {
      if (newValue != oldValue) {
        try {
          if (this.web3) {
            this.hasAcquired = false;
            this.isWhitelisted = " ";
            this.outputTokenName = " ";
            this.maxInvestment = 0;
            this.inputTokenSymbol = "";
            this.inputTokenDecimals = 0;

            const targetContractAddress = Web3.utils.toChecksumAddress(newValue);
            const targetContractAbi = AstroshotV2ABI as any as AbiItem;
            const targetContract = new this.web3.eth.Contract(targetContractAbi, targetContractAddress);

            const results = await Promise.all<boolean, string, string, number>([
              targetContract.methods.checkWhitelist(this.walletAddress).call(),
              targetContract.methods.inputtoken().call(),
              targetContract.methods.outputtoken().call(),
              targetContract.methods.maxInvestment().call(),
            ]);
            this.isWhitelisted = results[0] ? "YOU ARE WHITELISTED" : "YOU ARE NOT WHITELISTED";

            const genericContractAbi = GenericContractABI as any as AbiItem;

            const outputTokenContractAddress = Web3.utils.toChecksumAddress(results[2]);
            const outputTokenContract = new this.web3.eth.Contract(genericContractAbi, outputTokenContractAddress);

            this.outputTokenName = await outputTokenContract.methods.name().call();

            this.inputTokenContractAddress = Web3.utils.toChecksumAddress(results[1]);
            const inputTokenContract = new this.web3.eth.Contract(genericContractAbi, this.inputTokenContractAddress);

            const inputTokenInfo = await Promise.all<string, any, any, any>([
              inputTokenContract.methods.symbol().call(),
              inputTokenContract.methods.decimals().call(),
              inputTokenContract.methods.balanceOf(this.walletAddress).call(),
              inputTokenContract.methods
                .allowance(Web3.utils.toChecksumAddress(this.walletAddress), Web3.utils.toChecksumAddress(this.presaleContractAddress))
                .call(),
            ]);
            this.inputTokenSymbol = inputTokenInfo[0];
            this.inputTokenDecimals = inputTokenInfo[1];
            this.maxInvestment = results[3] / Math.pow(10, this.inputTokenDecimals);
            this.yourInputTokenBalance = inputTokenInfo[2] / Math.pow(10, this.inputTokenDecimals);
            const allowanceResult = Web3.utils.toBN(inputTokenInfo[3]);
            console.log(allowanceResult);
            this.isApproved = allowanceResult.gte(Web3.utils.toBN(this.maxInvestment * Math.pow(10, this.inputTokenDecimals)));
            console.log(this.isApproved);

            this.hasAcquired = true;
          }
        } catch (error) {
          // とりあえず何もしない。
        }
      }
    },
    gasLimit(newValue, oldValue) {
      if (newValue != oldValue) {
        if (newValue == null) {
          this.gas = " ";
        }
        try {
          const gasLimit = Web3.utils.toBN(this.gasLimit);
          const gasPrice = Web3.utils.toBN(this.gasPrice);
          this.gas = Web3.utils.fromWei(gasLimit.mul(gasPrice).toString(), "gwei");
        } catch (error) {
          this.gas = " ";
        }
      } else {
        this.gas = " ";
      }
    },
    gasPrice(newValue, oldValue) {
      if (newValue != oldValue) {
        if (newValue == null) {
          this.gas = " ";
        }
        try {
          const gasLimit = Web3.utils.toBN(this.gasLimit);
          const gasPrice = Web3.utils.toBN(this.gasPrice);
          this.gas = Web3.utils.fromWei(gasLimit.mul(gasPrice).toString(), "gwei");
        } catch (error) {
          this.gas = " ";
        }
      } else {
        this.gas = " ";
      }
    },
  },
});
